import moment from 'moment';
import { DATA_EXPORT_TYPE } from '../../constants';

export function formatDate  (value,langCode){
  const dateFormatOptions = {
    month: 'short', day: 'numeric', year:'numeric'
   }
  return new Intl.DateTimeFormat(langCode || 'en', dateFormatOptions).format(new Date(value));
}

export default function getDateRangeInMoment (dates, endDate, reportName) {
  var startDate;
  var rangelist = [];

  if(reportName === DATA_EXPORT_TYPE.TRANSACTIONS){
      startDate= moment(dates.minTranExportDate,  "DD-MM-YYYY");
  }
  if(reportName === DATA_EXPORT_TYPE.POSITIONS){
    startDate= moment(dates.minPosExportDate,  "DD-MM-YYYY");
  }
 
  for (var current = startDate; current < endDate; current.add(1, 'd')) {
    rangelist.push(current.clone());
  }
  return rangelist;
}

export function isDatePickerOpen (datepickerRef){
  return (datepickerRef &&
  datepickerRef.componentRef && 
  datepickerRef.componentRef.datepickerResponsiveRef && 
  datepickerRef.componentRef.datepickerResponsiveRef.datepicker && 
  datepickerRef.componentRef.datepickerResponsiveRef.datepicker.state && 
  datepickerRef.componentRef.datepickerResponsiveRef.datepicker.state.isOpen &&
  datepickerRef.componentRef.datepickerResponsiveRef.datepicker.state.isOpen === true
)  ? true :false
}